export default __webpack_public_path__ + "static/pattern-9a8fcc8bebf7b316abfac5d0bfbf5d64.png";